import ModalBody from '@/components/Modal/common/ModalBody';
import { Button, Modal } from '@mui/material';

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  text: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const ConfirmationModal = ({
  open,
  onClose,
  text,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
}: IProps) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby='modal-title'>
      <ModalBody>
        <p id='modal-title' className='mb-2 font-semibold'>
          {text}
        </p>
        <div className='flex justify-end gap-[9px]'>
          <Button variant='contained' onClick={onConfirm}>
            {confirmButtonText}
          </Button>
          <Button variant='outlined' color='error' onClick={onClose}>
            {cancelButtonText}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
